module.exports = __webpack_public_path__ + "static/media/thumb.34a3196b.jpg";